import { User } from '../../../../../services/user.service';

(() => {
  class UserInformationController {
    constructor(toastr, Notifications, Users, Utils) {
      'ngInject';

      Object.assign(this, {
        toastr,
        Notifications,
        Users,
        Utils
      });
    }

    $onInit() {
      this.user = new User(this.user);
      this.userCopy = angular.copy(this.user);

      if (!this.userCopy.opt_out_marketing_messages) {
        this.sendMarketingMsg = false;
      } else {
        this.sendMarketingMsg = true;
      }

      if (!this.userCopy.opt_out_email_messages) {
        this.sendEmail = false;
      } else {
        this.sendEmail = true;
      }

      if (!this.userCopy.opt_out_sms_messages) {
        this.sendText = false;
      } else {
        this.sendText = true;
      }

      if (this.userCopy.devices.length) {
        this.userCopy.devices = _.groupBy(this.userCopy.devices, 'platform');
      } else {
        delete this.userCopy.devices;
      }
    }

    update() {
      try {
        const payload = this.Utils.findDifference(this.user, this.userCopy);

        if (_.isEmpty(payload)) {
          return;
        }

        this.updating = true;
        this.Users.update(this.user.id, payload).then(() => {
          this.user = angular.copy(this.userCopy);
          this.toastr.success(this.Notifications.users.updateSuccess);
        }).catch(e => {
          if (e.status === 409) {
            this.toastr.error(this.Notifications.users.emailInUse);
          } else {
            this.toastr.error(this.Notifications.generic.failure);
          }
        }).finally(() => {
          this.updating = false;
        });
      } catch (e) {
        this.updating = false;

        if (e.message === 'Invalid Email') {
          this.toastr.error(this.Notifications.users.invalidEmail);
        }
      }
    }

    updateUserProperties() {
      if (this.userCopy.properties) {
        const {
          properties
        } = this.userCopy;
        const promises = [];

        for (const property in properties) {
          var value = properties[property];
          if (!value) value = "";
          promises.push(this.Users.updateUserProperty(this.userCopy.id, property, value));
        }

        this.updating = true;
        Promise.all(promises).then(() => {
          this.toastr.success('User properties updated.');
          this.updating = false;
        }).catch(err => {
          this.Utils.createErrorToast(err, 'Could not update user properties');
          this.updating = false;
        });
      }
    }

    dontSendMarketingMsg() {
      var marketingData;

      if (this.sendMarketingMsg) {
        marketingData = {
          "opt_out_marketing_messages": 1
        };
      } else {
        marketingData = {
          "opt_out_marketing_messages": 0
        };
      }

      this.Users.updateOptOutNotification(this.userCopy.id, marketingData).then(() => {
        this.toastr.success('User opt out Marketing notifications updated.');
      }).catch(err => {});
    }

    dontSendEmail() {
      var emailData;

      if (this.sendEmail) {
        emailData = {
          "opt_out_email_messages": 1
        };
      } else {
        emailData = {
          "opt_out_email_messages": 0
        };
      }

      this.Users.updateOptOutNotification(this.userCopy.id, emailData).then(() => {
        this.toastr.success('User opt out Email notifications updated.');
      }).catch(err => {});
    }

    dontSendText() {
      var smsData;

      if (this.sendText) {
        smsData = {
          "opt_out_sms_messages": 1
        };
      } else {
        smsData = {
          "opt_out_sms_messages": 0
        };
      }

      this.Users.updateOptOutNotification(this.userCopy.id, smsData).then(() => {
        this.toastr.success('User opt out SMS notifications updated.');
      }).catch(err => {});
    }

  }

  UserInformationController.$inject = ["toastr", "Notifications", "Users", "Utils"];
  angular.module('pims').component('userInformation', {
    templateUrl: 'app/views/users/detail/tabs/information/user-information.tab.html',
    controller: UserInformationController,
    bindings: {
      user: '<'
    }
  });
})();
